import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ReadCustomCode } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { CustomCodeScope, customCodesQueryKey } from './custom-codes-query-key';

export const getCustomCodes = async (
  scope: CustomCodeScope,
): Promise<ReadCustomCode[]> => {
  return await tinctApi.customCodes.getCustomCodes(scope);
};

export const useGetCustomCodes = (
  scope: CustomCodeScope,
  options?: Omit<UseQueryOptions<ReadCustomCode[], ApiError>, 'queryKey'>,
) =>
  useQuery({
    queryKey: customCodesQueryKey(scope),
    queryFn: () => getCustomCodes(scope),
    ...options,
  });
